import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ResourcesService } from '../../../../core/framework/resources.service';
import { AppConfigService, VersionDescriptor } from '../../../../configuration/app.config.service';
import { Subscription } from 'rxjs';
import { LanguageService } from '@m4u-angular/core/framework/language.service';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

@Component({
    selector: 'm4u-login-page',
    templateUrl: './login-base.component.html',
    styleUrls: ['./login-base.component.scss']
})
export class LoginBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() MainTitle: string;
    @Input() AdditionalTitle: string;

    IsMultiLanguage: boolean;
    Language: string;
    ModulesVersion: VersionDescriptor[] = [];

    private _subscriptions: Subscription[] = [];

    constructor(public resourcesService: ResourcesService,
        private appConfigService: AppConfigService,
        private languageService: LanguageService,
        public screen: ScreenService) {
    }

    ngOnInit() {
        this.IsMultiLanguage = this.appConfigService.M4UConfig.isMultiLanguage;
        this._subscriptions.push(this.languageService.Language$.subscribe(language => !this.Language && (this.Language = language)));
        this.ModulesVersion = this.appConfigService.getModulesVersion();
    }

    ngAfterViewInit() {
        // this is for correct elements direction change on language switch
        const rtlElements = document.querySelectorAll('.login-form-content .dx-rtl');
        rtlElements.forEach(x => x.classList.remove('dx-rtl'));
    }

    OnLanguageChanged(e) {
        this.languageService.SetLanguage(this.Language);
    }

    GetAppTitle() {
        const moduleName = this.GetFirstModuleName();
        return this.resourcesService.RC('$$AppTitles.LoginAppName', moduleName);
    }

    GetAppCompanyName() {
        const moduleName = this.GetFirstModuleName();
        return this.resourcesService.RC('$$AppTitles.LoginCompanyName', moduleName);
    }

    GetFirstModuleName() {
        const moduleNames = this.appConfigService.AppConfig.ModuleName.split(',');
        return moduleNames[0];
    }

    GetLanguageIcon() {
        const path = 'assets/icons/';
        const iconName = this.Language === EnumLanguages.English ? 'en.ico' : 'he.ico';
        return `${path}${iconName}`;
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(x => x.unsubscribe());
    }
}
